import { useState, useCallback } from "react";

export default function useForm(initialState = {}) {
  const [formState, setFormState] = useState({ ...initialState });

  const handleFormState = useCallback(
    (name, value) => {
      if (name) {
        setFormState((prev) => ({ ...prev, [name]: value }));
      }
    },
    []
  );

  const resetForm = useCallback(() => {
    setFormState({ ...initialState });
  }, [initialState]);

  return [formState, handleFormState, resetForm];
}
